__turbopack_context__.v({
  "box": "CodonationBox-module__9zaycW__box",
  "container": "CodonationBox-module__9zaycW__container",
  "heading": "CodonationBox-module__9zaycW__heading",
});
